export type ResolverTask = "translate" | "phonetic_resolve";

export type LanguagePair = {
  sourceLanguage: string;
  targetLanguage: string;
};

export const PHONETIC_LANGUAGE_PAIRS: LanguagePair[] = [
  { sourceLanguage: "ja", targetLanguage: "zh" },
  { sourceLanguage: "zh", targetLanguage: "ja" },
  { sourceLanguage: "ja", targetLanguage: "en" },
  { sourceLanguage: "en", targetLanguage: "ja" },
  { sourceLanguage: "en", targetLanguage: "zh" },
  { sourceLanguage: "zh", targetLanguage: "en" },
];

export const PHONETIC_PAIR_STORAGE_KEY = "fluentry:phonetic-resolver:pair";

export function suggestResolverTask(input: string): { task: ResolverTask; reason: string } {
  const text = input.trim();
  if (!text) {
    return { task: "phonetic_resolve", reason: "入力が短いため、聞き取り語推定から始めるのが適しています。" };
  }

  const tokenCount = text.split(/\s+/).filter(Boolean).length;
  const hasSentenceMarker = /[.!?。！？,，、]/.test(text);
  const hasKana = /[\u3040-\u30ff]/.test(text);
  const letterCount = (text.match(/[a-zA-Z]/g) || []).length;
  const alphaNumCount = (text.match(/[a-zA-Z0-9]/g) || []).length;
  const romanRatio = alphaNumCount === 0 ? 0 : letterCount / alphaNumCount;

  const looksPhonetic =
    text.length <= 24 && tokenCount <= 4 && !hasSentenceMarker && (hasKana || romanRatio >= 0.6);

  if (looksPhonetic) {
    return {
      task: "phonetic_resolve",
      reason: "短い音写入力のため、聞き取り語推定が向いています。",
    };
  }

  return {
    task: "translate",
    reason: "文としての構造があるため、文章変換が向いています。",
  };
}

export function detectPairFromBrowserLanguage(language: string | undefined): LanguagePair {
  const normalized = (language || "").toLowerCase();

  if (normalized.startsWith("ja")) {
    return { sourceLanguage: "ja", targetLanguage: "zh" };
  }
  if (normalized.startsWith("zh")) {
    return { sourceLanguage: "zh", targetLanguage: "en" };
  }
  if (normalized.startsWith("en")) {
    return { sourceLanguage: "en", targetLanguage: "zh" };
  }

  return { sourceLanguage: "en", targetLanguage: "zh" };
}

export function isSupportedPair(pair: LanguagePair): boolean {
  return PHONETIC_LANGUAGE_PAIRS.some(
    (item) =>
      item.sourceLanguage === pair.sourceLanguage && item.targetLanguage === pair.targetLanguage,
  );
}

